import type { Capability } from '@/util/roles/capabilities'
import type { Operation } from '@/util/roles/generated'
import { type RouteLocationNormalized, type RouteLocationRaw } from 'vue-router'

/**
 * Update the title of the document.
 * @param {string|undefined} title - The new title to be set.
 */
export const updateTitle = (title: string | undefined) => {
  document.title = title ? `${title} | Galvanick` : 'Galvanick'
}

/**
 * Where to send a user whose capabilities deny them `to`, or `undefined` to let
 * them through: the route's `deniedRedirect` if it names one, otherwise the 403 page.
 */
export const capabilityRedirect = (
  to: RouteLocationNormalized,
  auth: {
    isLoggedIn: boolean
    can: (target: Capability | Operation) => boolean
  },
): RouteLocationRaw | undefined => {
  const required = to.meta.requiredCapability
  // Signed out there are no roles yet, and denying now would make the 403 the post-login redirect.
  if (!required || !auth.isLoggedIn || auth.can(required)) return undefined
  return to.meta.deniedRedirect
    ? { name: to.meta.deniedRedirect }
    : { name: '403', query: { path: to.path } }
}
